import styled from "styled-components";

interface IContainer {
  width?: string;
}
export const Container = styled.div<IContainer>`
  ${({ theme }) => `
    background-color: ${theme.colors.white};
  `}
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  padding: 4rem 3.2rem;
  width: ${(props) => (props.width ? props.width : "61.2rem")};
`;

export const ContainerScroll = styled.div`
  .scroll {
    height: auto;
    overflow: auto;
    width: auto;
  }
  .scroll::-webkit-scrollbar {
    width: 3px;
  }

  .scroll::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px #76bc21;
  }
`;

interface IContainerConfigurate {
  width?: string;
  minHeight?: string;
  maxHeight?: string;
}
export const ContainerConfigurate = styled.div<IContainerConfigurate>`
  ${(props) => `
  background-color: ${props.theme.colors.white};
  width: ${props.width ? props.width : "49.5rem"};
  min-height: ${props.minHeight ? props.minHeight : "0vh"};
  max-height: ${props.maxHeight ? props.maxHeight : "33vh"};
  @media (max-width: 750px) {
    width: 48rem;
  }
  `}
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 4rem 3.2rem;
`;
interface IButtonGeneric {
  backgroundColor?: string;
  border?: string;
  height?: string;
  marginTop?: string;
  marginBottom?: string;
  width?: string;
  marginRight?: string;
  marginLeft?: string;
}
export const ButtonGeneric = styled.button<IButtonGeneric>`
  ${(props) => `
  font-family: ${props.theme.fontFamilies.primaryFont};
  background-color: ${
    props.backgroundColor ? props.backgroundColor : props.theme.colors.white
  };
  border: ${
    props.border ? props.border : `1px solid ${props.theme.colors.primaryBlue}`
  };
  color: ${props.color ? props.color : props.theme.colors.primaryBlue};
  height: ${props.height ? props.height : "5rem"};
  margin-top:${props.marginTop ? props.marginTop : "0rem"};
  margin-bottom: ${props.marginBottom ? props.marginBottom : "0rem"};
  width: ${props.width ? props.width : "100%"};
  margin-right:${props.marginRight ? props.marginRight : "0rem"};
  margin-left: ${props.marginLeft ? props.marginLeft : "0rem"};
  `}
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  font-size: 1.5rem;
  font-weight: 700;
  justify-content: center;
  

  .icon {
  height: 5rem;
  width: 5rem;
  }
  &:disabled,
  &[disabled] {
  cursor: not-allowed;
`;

interface IDivDetailTitle {
  fontWeight?: string | number;
  fontSize?: string;
}
export const DivDetailTitle = styled.div<IDivDetailTitle>`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
    font-weight:${props.fontWeight ? props.fontWeight : 800};
    font-size: ${props.fontSize ? props.fontSize : "1.4rem"};

  `}
  color: #2E353D;
`;

interface ISubtitle {
  textTransform?: any;
}
export const Subtitle = styled.h2<ISubtitle>`
  ${({ theme, textTransform }) => `
      color: ${theme.colors.primaryBlue};
      text-transform:${textTransform ? textTransform : "uppercase"};
    `}
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1.9rem;
  margin-top: 0;
`;
export const SubtitleRecaudo = styled.h2<ISubtitle>`
  ${({ theme }) => `
      color: ${theme.colors.primaryBlue};
    `}
  font-size: 1.8rem;
  font-weight: 500;
  margin-bottom: 1.9rem;
  margin-top: 0;
`;

export const TitleType = styled.h2`
  color: rgba(46, 53, 61, 0.3);
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 0;
  text-transform: uppercase;
`;

export const Title = styled.h1`
  ${({ theme }) => `
    color: ${theme.colors.blackTextBody};
  `}
  font-size: 2.4rem;
  font-weight: 800;
  margin-bottom: 0.2rem;
  margin-top: 0.5rem;
`;

interface ISectionTitle {
  width?: string;
}
export const SectionTitle = styled.h3<ISectionTitle>`
  ${(props) => `
    color: ${props.theme.colors.blackTextBody + props.theme.transparencies.p30};
    width: ${props.width ? props.width : "auto"};
  `}
  font-size: 1.4rem;
  font-weight: 700;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const HorizontalContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

interface IText {
  width?: string;
}
export const Text = styled.p<IText>`
  ${(props) => `
    color: ${props.theme.colors.blackTextBody};  
    width: ${props.width ? props.width : "100%"};
  `}
  font-size: 1.6rem;
  font-weight: 500;
`;

export const InfoContainer = styled.div`
  align-items: center;
  border-radius: 0.8rem;
  box-shadow: 0px 5px 30px rgba(231, 231, 234, 0.62);
  box-sizing: border-box;
  display: flex;
  height: 5rem;
  margin-bottom: 3rem;
  padding-left: 1.3rem;
  width: 43.1rem;

  & > p {
    ${({ theme }) => `
    color: ${theme.colors.blackTextBody};  
  `}
    font-size: 1.4rem;
    font-weight: 500;
    margin: 0;
  }
`;

interface IAmountDifference {
  backgroundColor?: string;
  labelColor?: string;
}
export const AmountDifference = styled.div<IAmountDifference>`
  background-color: ${(props) => props.backgroundColor};
  width: auto;
  height: 2.7rem;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
  label {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    color: ${(props) => props.labelColor};
  }
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
  }
`;

interface ITableBodyPers {
  gridTemplateColumns?: string;
}
export const TableBodyPers = styled.div<ITableBodyPers>`
  margin-bottom: 3rem;
  height: 16rem;

  & > div {
    grid-template-columns: ${(props) => props.gridTemplateColumns};
    margin-top: 0.8rem;
  }

  .clickable-element {
    cursor: pointer;
  }

  .edit-icon {
    background-color: ${(props) => props.theme.colors.primaryBlue};

    align-items: center;
    border: none;
    border-radius: 1rem;
    cursor: pointer;
    display: flex;
    height: 3.8rem;
    justify-content: center;
    width: 3.8rem;

    & > img {
      height: 1.9rem;
      width: 1.9rem;
    }

    :hover {
      background-color: ${(props) => props.theme.colors.primaryBlue} !important;
      border-color: ${(props) => props.theme.colors.primaryBlue} !important;
    }
  }
`;

interface ITableHeaderPers {
  gridTemplateColumns?: string;
}
export const TableHeaderPers = styled.div<ITableHeaderPers>`
  ${({ gridTemplateColumns, theme }) => `
    color: ${theme.colors.gray};
    font-family: ${theme.fontFamilies.primaryFont};
    grid-template-columns: ${gridTemplateColumns};
  `}
  box-sizing: border-box;
  display: grid;
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  margin-top: 3rem;
  padding: 0 1rem;
  margin-right: 2rem;

  .center {
    text-align: center;
  }

  & > div {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .left-align {
    align-items: flex-start;
  }
`;

interface IRowPers {
  height?: string;
}
export const RowPers = styled.div<IRowPers>`
  ${({ theme, height }) => `
    background-color: ${theme.colors.white};
    min-height: ${height ? height : "7.2rem"};
  `}

  border-radius: 0.5rem;
  box-sizing: border-box;
  display: grid;
  font-size: 1.4rem;
  font-weight: 500;
  padding: 0 1rem;

  border: 1px solid #c6c8ce;
  height: 6.2rem;
  margin-right: 1rem;
  margin-top: 0rem !important;

  &.clickable {
    cursor: pointer;
  }

  & > div {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .left-align {
    align-items: flex-start;
    flex-direction: column;
  }

  .actions {
    display: flex;
    gap: 1rem;
  }
`;

interface IDetailButton {
  width?: string;
  marginRight?: string;
  marginLeft?: string;
}
export const DetailButton = styled.button<IDetailButton>`
  ${({ theme }) => `
    background-color: ${theme.colors.white};
    border: solid 1px ${theme.colors.accentGreen};
    color: ${theme.colors.accentGreen};
  `};

  align-items: center;
  border-radius: 1rem;
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: 1.6rem;
  font-weight: 700;
  height: 6.2rem;
  justify-content: center;
  width: ${(props) => (props.width ? props.width : "20.6rem")};

  margin-right: ${(props) => (props.marginRight ? props.marginRight : "0rem")};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "0rem")};
  & > img {
    height: 1.5rem;
    margin-right: 1rem;
    width: 1.5rem;
  }
`;

interface IApproveCompensationButton {
  width?: string;
}
export const ApproveCompensationButton = styled.button<IApproveCompensationButton>`
  background-color: ${(props) => (props.disabled ? "#c6c8ce" : "#88B13B")};
  color: ${({ theme }) => theme.colors.white};
  ${(props) => (props.disabled ? "cursor: not-allowed;" : "")}
  align-items: center;
  border: none;
  border-radius: 1rem;
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: 1.6rem;
  font-weight: 700;
  height: 6.2rem;
  justify-content: center;
  width: ${(props) => (props.width ? props.width : "20.6rem")};

  & > img {
    height: 2.1rem;
    margin-right: 1rem;
    width: 2.1rem;
  }
`;

export const ContainerInfo = styled.div`
  height: auto;
  width: 100%;
  overflow-y: auto;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;

  &::-webkit-scrollbar-thumb {
    background: #76bc21;
    border-radius: 1rem;
    box-shadow: inset 0 0 0.6rem #76bc21;
    height: 244px;
  }
  &::-webkit-scrollbar {
    width: 3px;
    background-color: #ededed;
  }

  @media (max-height: 750px) {
    overflow-y: auto;
    height: 500px;
    overflow-x: hidden;
  }
  @media (max-height: 670px) {
    height: 400px;
  }
  @media (max-height: 570px) {
    height: 300px;
  }
`;

export const HorizontalLine = styled.div`
  width: 100%;
  background: #000000;
  height: 0.1rem;
  float: left;
  opacity: 0.1;
`;

export const ErrorMessage = styled.div`
  height: 2.7rem;
  background: rgb(255, 111, 97);
  margin-top: 0px !important;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  label {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 2rem;
    text-align: center;
    color: rgb(255, 255, 255);
  }
`;

interface IMessageInformative {
  backgroundColor?: string;
}
export const MessageInformative = styled.div<IMessageInformative>`
  width: 97.5%;
  min-height: 3.4rem;
  height: auto;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : "rgb(255, 248, 218)"};
  margin-top: 1.6rem;
  display: flex;
  align-items: center;

  .icon-message {
    margin-right: 1rem;
    margin-left: 1.2rem;
  }
  .message-info {
    width: auto;
    height: auto;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    padding-right: 1rem;
    font-size: 1.4rem;
    color: ${(props) => (props.color ? props.color : "#000000")};
  }
`;

interface IItemInfoPanel {
  paddingLeft?: string;
  fontSize?: string;
}
export const ItemInfoPanel = styled.div<IItemInfoPanel>`
  width: 100%;
  height: 5rem;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 10px 0px 0px 0px;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: -0.1rem 0rem;
  display: flex;
  align-items: center;
  padding-left: ${(props) =>
    props.paddingLeft ? props.paddingLeft : "2.2rem"};

  h1 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
    font-size: ${(props) => (props.fontSize ? props.fontSize : "14px")};
    line-height: 17px;
    color: ${(props) => (props.color ? props.color : "#000000")};
    flex: none;
    order: 0;
    flex-grow: 0;
  }
`;

export const ContainerItems = styled.div`
  height: 100%;
  overflow: auto;

  &::-webkit-scrollbar-thumb {
    background: #76bc21;
    border-radius: 1rem;
    box-shadow: inset 0 0 0.6rem #76bc21;
    height: 7.9rem;
  }
  &::-webkit-scrollbar {
    width: 1.2rem;
    background-color: #ededed;
  }
`;

interface IButtonOverlList {
  width?: string;
  height?: string;
  fontSizeCounLabel?: string;
  iconCountWith?: string;
  iconCountHeight?: string;
  marginRight?: string;
}
export const ButtonOverlList = styled.div<IButtonOverlList>`
  max-width: 25rem;
  width: ${(props) => (props.width ? props.width : "auto")};
  max-height: 3.2rem;
  height: ${(props) => (props.height ? props.height : "3.2rem")};
  display: flex;
  flex-direction: row !important;
  align-items: center;
  justify-content: space-between;
  margin-right: ${(props) => (props.marginRight ? props.marginRight : "0rem")};

  .first-value {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: ${(props) =>
      props.fontSizeCounLabel ? props.fontSizeCounLabel : "2.6rem"};
    color: #002e6c;
    margin-left: 10px;
    cursor: default;
    width: 9rem;
  }
  .conent-icons {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row !important;
    .icon-count {
      width: ${(props) =>
        props.iconCountWith ? props.iconCountWith : "4.1rem"};
      height: ${(props) =>
        props.iconCountHeight ? props.iconCountHeight : "3.2rem"};
      background: rgb(242, 243, 248);
      display: flex;
      align-items: center;
      justify-content: center;
      h1 {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 600;
        font-size: 1.6rem;
        line-height: 2rem;
        color: #2e353d;
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 0;
      }
    }
  }
`;

interface IDivFirstValue {
  fontSize?: string;
  fontWeight?: string | number;
  marginLeft?: string;
  width?: string;
}
export const DivFirstValue = styled.div<IDivFirstValue>`
  ${(props) => `
    color:${props.color ? props.color : "#002e6c"};
    font-family: ${props.theme.fontFamilies.primaryFont};
    font-size:${props.fontSize ? props.fontSize : "1.4rem"};
    font-style: normal;
    font-weight: ${props.fontWeight ? props.fontWeight : 500};
    margin-left:${props.marginLeft ? props.marginLeft : "1rem"};
    width: ${props.width ? props.width : "9rem"};
  `}
  cursor: default;
`;

export const DivQuotationSide = styled.div`
  align-items: center;
  border-radius: 0.5rem;
  border: 0.1rem solid #c6c8ce;
  display: flex;
  height: 4.7rem;
  justify-content: space-between;
  margin-right: 1.5rem;
`;

export const DivFlexCenterQuotation = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 1.2rem;
`;

export const LabelQuotationTci = styled.label`
  color: #2e353d;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 500;
  text-align: center;
`;

export const DivFlexCenterIcon = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 1.2rem;
`;

interface IPWarningComment {
  width?: string;
}
export const PWarningComment = styled.p<IPWarningComment>`
  overflow-wrap: break-word;
  width: ${(props) => (props.width ? props.width : "47rem")};
`;

export const DivOverFlowPayment = styled.div`
  max-height: 100vh;
  @media (max-height: 820px) {
    overflow-y: auto;
    max-height: 90vh;
  }
`;

export const DivInformationBankDetails = styled.div`
  color: #2e353d;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-size: 1.6rem;
  margin-left: 3rem;
`;

export const DivBankInformation = styled.div`
  align-items: center;
  background: rgba(255, 111, 97, 0.1);
  color: #ff6f61;
  display: flex;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-size: 1.4rem;
  margin-bottom: 1rem;
  margin-top: 2rem;
  padding: 0.8rem;
  width: 97%;
`;

export const DivJustifyScreenplay = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
